import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { HeadAccountCgtSettings } from '../../Models/Domains/Tax/HeadAccountCgtSettings';

declare var IS_RUNNING_IN_APP_POOL;

export class HeadAccountCgtSettingsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(settings: HeadAccountCgtSettings): Promise<HeadAccountCgtSettings, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Tax/HeadAccountCgtSettings/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { settings: settings }

    return AjaxWrapper.post<HeadAccountCgtSettings, any>(url, data);
  }
  public get(hierarchyId: string): Promise<HeadAccountCgtSettings, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Tax/HeadAccountCgtSettings/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.get<HeadAccountCgtSettings, any>(url, data);
  }
}

